var map = {
	"./custom-page/state/middleware": [
		9100,
		1480
	],
	"./dashboard-widgets/state/middleware": [
		74384,
		4384
	],
	"./dashboard/state/middleware": [
		70532,
		532
	],
	"./view-widgets/state/middleware": [
		61080,
		1080
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77020;
module.exports = webpackAsyncContext;